var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quickCheckSettingGrade"},[_vm._m(0),_c('div',{staticClass:"main-con"},[_c('slider',{on:{"load-table":_vm.handleLoadTable}}),_c('RBtableList',{ref:"RBtableList",attrs:{"current-data":'currentData'}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-con"},[_c('h4',[_vm._v("快检指标设置")])])
}]

export { render, staticRenderFns }